import script from "./detailModule.vue?vue&type=script&setup=true&lang=js"
export * from "./detailModule.vue?vue&type=script&setup=true&lang=js"

import "./detailModule.vue?vue&type=style&index=0&id=3809360b&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3809360b"]])

export default __exports__